import PrintIcon from '@mui/icons-material/Print';
import { Button, Stack, ButtonGroup, Paper, Popper, MenuItem, MenuList, ClickAwayListener, Grow, TextField as MTextField } from '@mui/material';
import * as React from 'react';
import { useNotify, useRecordContext, useTranslate } from 'react-admin';
import { getToken } from '../authentication/authProvider';
import { Contract } from '../types';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';

const PAPERMAN_API_URL = process.env.REACT_APP_PAPERMAN_API_URL;
const options = ['Print Today', 'Print Tomorrow'];

const DisplayScheduleButton = () => {

  const notify = useNotify();
  
  const displaySchedule = async (date: string) => {
    const todayDate = new Date().toISOString().replace(/T.*/,'').split('-').join('-');
    const tomorrow = new Date(new Date().setDate(new Date().getDate()+1)).toISOString().replace(/T.*/,'').split('-').join('-');

    let dateToDisplay = todayDate;

    if(date == 'tomorrow'){
      dateToDisplay = tomorrow;
    }
    if(date != 'tomorrow' && date != 'today'){
      dateToDisplay = date;
    }

    try {
      const result = await fetch(
        PAPERMAN_API_URL + `funerals/en/` + dateToDisplay
        ,
        {
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );

      if (result.status >= 200 && result.status < 300) {
        const blob = await result.blob();
        window.open(URL.createObjectURL(blob), '_blank');
      } else {
        notify(translate('resources.funerals.shedule_error'));
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      console.warn(e);

      notify(e.message ?? JSON.stringify(e));
    }
  };

  const translate = useTranslate();
  const record = useRecordContext<Contract>();

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [showDatePicker, setShowDatePicker] = React.useState(true);
  const [selectedDate, setSelectedDate] = React.useState<Date | null>(null);

  const handleClick = () => {
    void displaySchedule('today');
  }

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    console.info(`You clicked ${options[index]}`);
    if(index == 0){
      void displaySchedule('today');
    }
    if(index == 1){
      void displaySchedule('tomorrow');
    }
    else{


      void displaySchedule('2023-05-01')
    }
    setOpen(false);
  };

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    if(date){
      void displaySchedule(moment(date).format('YYYY-MM-DD'));
    }
  };


  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };


  return (
      <>
      <ButtonGroup variant="outlined" ref={anchorRef} aria-label="split button">
      <Button onClick={handleClick}>{options[selectedIndex]}</Button>
      <Button
        size="small"
        aria-controls={open ? 'split-button-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-label="select merge strategy"
        aria-haspopup="menu"
        onClick={handleToggle}
      >
        <ArrowDropDownIcon />
      </Button>
    </ButtonGroup>
    <Popper
      sx={{
        zIndex: 10,
      }}
      open={open}
      anchorEl={anchorRef.current}
      role={undefined}
      transition
      disablePortal
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === 'bottom' ? 'center top' : 'center bottom',
          }}
        >
          <Paper>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList id="split-button-menu" autoFocusItem>
                {options.map((option, index) => (
                  <MenuItem
                    key={option}
                    selected={index === selectedIndex}
                    onClick={(event) => handleMenuItemClick(event, index)}
                  >
                    {option}
                  </MenuItem>
                ))}
                <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  value={selectedDate}
                  onChange={handleDateChange}
                  renderInput={(params) => <MTextField {...params} />}
                />
                </LocalizationProvider>
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
    </>
  );
};

export default DisplayScheduleButton;

